import {useTranslation} from "react-i18next";
import Page from "../../common/page/Page";
import {MessageStateTranslKey} from "./MessageStateTranslKey";
import MessageStateSearchPanel from "./MessageStateSearchPanel";

export function MessageStatePage() {
    const {t} = useTranslation();

    return (
        <Page title={t(MessageStateTranslKey.ISDS_STATE_OVERVIEW)}>
            <MessageStateSearchPanel />
        </Page>
    );
}
